import { ReactNode } from "react";

const AccountWatermarks = ({ children, text = "CONFIDENTIAL" }: {children: ReactNode, text: ReactNode}) => {
    return (
        <div className="relative">
            <div className="absolute z-50 w-full h-full flex items-center justify-center pointer-events-none">
                <div className="flex flex-col text-center">
                    <span className="text-green-900 mt-1 dark:text-slate400 font-public-sans uppercase text-4xl font-bold opacity-20 select-none">
                        {text}
                    </span>
                </div>
            </div>
            <div className="relative">{children}</div>
        </div>
    );
};

export default AccountWatermarks;
